export default "__VITE_ASSET__DWm3CwDQ__"